import React, { Component } from 'react';
import Slide from './Slide';
import './Carousel.css';
import Slider from 'react-slick';

export default class Carousel extends Component {

    state = {
        active: 0,
        middle: 0,
        data: {
            display: "Canvas Watches",
            description: "Welcome to my gallery of Watchmaker Pro watches, converted for your viewing pleasure to HTML Canvas elements. Not only did I design the watches myself, I also wrote the Node.js software to convert their appearance and behavior to JavaScript. 'Canvas Watches' is an ongoing project. If you have ideas for its improvement, please click the link below and contribute on GitHub.",
            technical: "The biggest challenge in getting them to be displayed on my homepage was to segregate them. The JavaScript files must be loaded separately or they may have strange interactions, so I rendered each watch in its own iframe. Getting React.js to pass information along into that iframe was tricky indeed! Please scroll around for information about each watch design.",
            link: "https://github.com/evansimonross/Canvas-Watches"
        }
    }

    render() {
        var { slides } = this.props;
        if (slides.length === 0) return <div />;

        var { active, data } = this.state;

        var settings = {
            className: "center",
            centerMode: true,
            infinite: true,
            centerPadding: "50px",
            slidesToShow: 3,
            speed: 500,
            beforeChange: (current, next) => {
                document.getElementById("watch-info").style.opacity=0;
                this.setState({ active: next });
            },
            afterChange: current => {
                document.getElementById("watch-info").style.opacity=1;
                this.setState({ middle: current, data: slides[current] })
            },
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
              ]
        };

        return (
            <div className="carousel-container">
                <div className="carousel">
                    <Slider {...settings}>
                        {slides.map((e, i) => (
                            <Slide index={i} key={e.name} data={e} isActive={active === i} />
                        ))}
                    </Slider>
                </div>
                <div id="watch-info">
                    <h3>{data.display}</h3>
                    <p>{data.description}</p>
                    <p>{data.technical}</p>
                    <p><a target="_blank" href={data.link}>Click here to download {data.display}.</a></p>
                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js